import { z } from 'zod';

export const statusParcelaSchema = z.enum(['A_VENCER', 'VENCIDA', 'PAGA']);
export type StatusParcela = z.infer<typeof statusParcelaSchema>;

export const parcelaSchema = z.object({
  tenantId: z.string().min(1, 'TenantId é obrigatório'),
  orderId: z.string().min(1, 'OrderId é obrigatório'),
  numero: z.number().int().min(1, 'Número da parcela deve ser maior ou igual a 1'),
  valor: z.number().positive('Valor da parcela deve ser maior que zero'),
  dataVencimento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data de vencimento deve estar no formato YYYY-MM-DD'),
  valorPago: z.number().min(0, 'Valor pago não pode ser negativo'),
  status: statusParcelaSchema,
  ultimaCobrancaEm: z.string().optional(),
});

export type Parcela = z.infer<typeof parcelaSchema>;

export const gerarParcelasInputSchema = z.object({
  valorTotal: z.number().positive('Valor total deve ser maior que zero'),
  numeroParcelas: z.number().int().min(1).max(12, 'Máximo de 12 parcelas'),
  dataPrimeiroVencimento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inicial deve ser YYYY-MM-DD'),
});

export type GerarParcelasInput = z.infer<typeof gerarParcelasInputSchema>;
